// src/services/modules/Images.js
import { collection, doc, setDoc, addDoc, deleteDoc, getDocs, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage } from "../../../firebase"; // Configuración de Firebase

const imagesCollectionName = "products"; // Nombre de la colección en Firestore

// Subir un producto con imagen
export const uploadProduct = async (productData) => {
  const { imageFile, name, description, price } = productData;

  if (!imageFile) throw new Error("No se seleccionó una imagen.");

  try {
    // Subir imagen a Firebase Storage
    const fileRef = ref(storage, `products/${imageFile.name}`);
    await uploadBytes(fileRef, imageFile);
    const imageUrl = await getDownloadURL(fileRef);

    // Guardar metadatos en Firestore
    const collectionRef = collection(db, imagesCollectionName);
    const docRef = await addDoc(collectionRef, {
      name,
      description,
      price,
      imageUrl,
      createdAt: new Date(),
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error al subir producto:", error);
    throw error;
  }
};

// Actualizar un producto existente
export const updateProduct = async (id, updatedData) => {
  const { imageFile, name, description, price } = updatedData;

  try {
    let imageUrl;

    if (imageFile) {
      // Subir nueva imagen si es necesario
      const fileRef = ref(storage, `products/${imageFile.name}`);
      await uploadBytes(fileRef, imageFile);
      imageUrl = await getDownloadURL(fileRef);
    }

    // Actualizar datos en Firestore
    const docRef = doc(db, imagesCollectionName, id);
    await updateDoc(docRef, {
      name,
      description,
      price,
      ...(imageUrl && { imageUrl }), // Actualiza solo si hay una nueva imagen
    });

    return { success: true };
  } catch (error) {
    console.error("Error al actualizar producto:", error);
    throw error;
  }
};

// Eliminar un producto
export const deleteProduct = async (id, imageUrl) => {
  try {
    // Eliminar imagen de Firebase Storage
    if (imageUrl) {
      const fileRef = ref(storage, imageUrl);
      await deleteObject(fileRef);
    }

    // Eliminar metadatos de Firestore
    const docRef = doc(db, imagesCollectionName, id);
    await deleteDoc(docRef);

    return { success: true };
  } catch (error) {
    console.error("Error al eliminar producto:", error);
    throw error;
  }
};

// Obtener todos los productos
export const getProducts = async () => {
  try {
    const collectionRef = collection(db, imagesCollectionName);
    const snapshot = await getDocs(collectionRef);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error al obtener productos:", error);
    throw error;
  }
};
